import { Card, CardContent, Grid, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { useAppDispatch } from "../../store/customHooks";
import { DashboardEntity } from "../dashboard/entity";

const useStyles = makeStyles({
	card: {
		minHeight: "70%",
		height: "100%",
		width: "80%",
		boxShadow:
			"inset 4px 4px 6px 0 rgba(153, 166, 206, 0.3), inset -4px -4px 4px 0 #f5f5f5",
		backgroundColor: "white",
	},
	cardContent: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: "10%",
		fontWeight: 700,
		fontSize: "16px",
		color: "#2c3968",
		cursor: "pointer",
		marginTop:"20px"
	},
});

const Dashboard = () => {
	const classes = useStyles();
	const navigate = useNavigate();
	const dispatch = useAppDispatch();

	useEffect(() => {
		window.onpopstate = function (event) {
			window.history.go(1);
		};
	}, []);

	const onViewDetails = async (item: any) => {
		if (item?.endpoint === "GuestStatusBoard") {
			navigate("/dashboard/guestboard");
		} else if (item?.endpoint === "WelcomeBoard") {
			navigate(`/dashboard/welcomeboard`);
		} else {
			navigate("/dashboard/workshopboard");
		}
	};

	return (
		<Grid container >
			<Header position={'static'} />
			<Grid container>
				{DashboardEntity?.map((item: any) => (
					<Grid
						style={{
							display: "flex",
							justifyContent: "space-around",
							marginTop: "10%",
						}}
						key={item.label}
						item
						xs={12}
						sm={4}
						md={4}
					>
						<Card className={classes.card}>
							<CardContent
								onClick={(e: any) => {
									onViewDetails(item);
								}}
							>
								<Grid container className={classes.cardContent}>
									<Grid item><Stack sx={{textAlign: "center"}}
									>{item.label}</Stack></Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				))}
			</Grid>
		</Grid>
	);
};

export default Dashboard;
